export default "__VITE_ASSET__DMERXehe__"